import { render } from "./ReportViewModal.vue?vue&type=template&id=36c35ad3"
import script from "./ReportViewModal.vue?vue&type=script&lang=js"
export * from "./ReportViewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__